import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiRequestError, apiRequest } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Alert, Button, Field } from '../components/ui';

export function ChangePasswordPage() {
  const { refresh, mustChangePassword } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);

    if (newPassword !== confirmation) {
      setError('A confirmacao nao confere com a nova senha.');
      return;
    }

    setSubmitting(true);
    try {
      await apiRequest('/auth/me/password', {
        method: 'POST',
        body: { currentPassword, newPassword },
      });
      await refresh();
      navigate('/', { replace: true });
    } catch (caught) {
      setError(
        caught instanceof ApiRequestError ? caught.displayMessage : 'Nao foi possivel trocar a senha',
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="grid min-h-full place-items-center p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-4 rounded-xl border border-slate-200 bg-white p-6 shadow-sm"
      >
        <div>
          <h1 className="text-lg font-semibold text-slate-900">Definir nova senha</h1>
          <p className="text-sm text-slate-500">
            {mustChangePassword
              ? 'A troca e obrigatoria antes de usar o painel.'
              : 'Escolha uma nova senha para sua conta.'}
          </p>
        </div>

        {error ? <Alert>{error}</Alert> : null}

        <Field
          label="Senha atual"
          type="password"
          value={currentPassword}
          onChange={(event) => setCurrentPassword(event.target.value)}
          autoComplete="current-password"
          required
          autoFocus
        />

        <Field
          label="Nova senha"
          type="password"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          autoComplete="new-password"
          required
          minLength={10}
          hint="Minimo de 10 caracteres, com maiuscula, minuscula e numero."
        />

        <Field
          label="Confirmar nova senha"
          type="password"
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
          autoComplete="new-password"
          required
        />

        <Alert tone="info">
          As suas outras sessoes serao encerradas ao concluir a troca.
        </Alert>

        <Button type="submit" disabled={submitting} className="w-full">
          {submitting ? 'Salvando...' : 'Salvar nova senha'}
        </Button>
      </form>
    </div>
  );
}
